import React from 'react';
import { classNames } from '../../util/classNames';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

type BaseProps = {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'warning';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  as?: 'button' | 'a';
  className?: React.HTMLProps<HTMLElement>['className'];
};
type Props = (ButtonProps | AnchorProps) & BaseProps;

export const SnapButton = (props: Props) => {
  const {
    variant = 'primary',
    size = 'md',
    as = 'button',
    fullWidth = false,
    className = '',
    ...restProps
  } = props;

  const buttonStyles = classNames(
    'text-nowrap inline-flex items-center justify-center cursor-pointer rounded-[25px] font-medium bg-transparent shadow-sm',
    'disabled:bg-gray-100 disabled:border-gray-300 disabled:text-gray-400 disabled:pointer-events-none disabled:opacity-100',
    'focus:ring-1 focus:ring-blue-500 focus:ring-offset-1 focus:ring-offset-white',
    variant === 'primary'
      ? 'border border-blue-900 bg-blue-600 text-white hover:bg-blue-800 active:bg-blue-800 active:border-blue-500 '
      : '',
    variant === 'secondary'
      ? 'border border-blue-600 bg-blue-200 text-gray-900 hover:bg-blue-300 active:bg-blue-300 active:border-2'
      : '',
    variant === 'tertiary'
      ? 'border border-gray-300 bg-white text-gray-800 hover:bg-blue-200 active:bg-blue-100'
      : '',
    variant === 'warning'
      ? 'border border-red-900 bg-red-600 text-white hover:bg-red-800 active:bg-red-800 active:border-red-500 '
      : '',
    size === 'sm' ? 'px-4 py-1 text-sm' : '',
    size === 'md' ? 'px-8 py-2 text-sm' : '',
    size === 'lg' ? 'px-12 py-2 text-base' : '',
    size === 'xl' ? 'px-14 py-3 text-base' : '',
    fullWidth ? 'w-full' : '',
    className,
  );
  if (as === 'a') {
    return <a className={buttonStyles} {...(restProps as AnchorProps)} />;
  }
  return (
    <button
      className={buttonStyles}
      type='button'
      {...(restProps as ButtonProps)}
    />
  );
};
